export default "__VITE_ASSET__BANqc2U3__"